// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"errorPage_errorPageWrapper__5QEQ8","errorPageHero":"errorPage_errorPageHero__KFhcW","backButton":"errorPage_backButton__wj6Mg"};